export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT; //production | development

export const COMPANY_NAME = "iDoM";
export const PROJECT_META_NAME = "ido_meta";
export const PRODUCT_SLUG = process.env.REACT_APP_PRODUCT_SLUG || "hrms";

export const config = {
  apiurl:
    ENVIRONMENT === "production"
      ? process.env.REACT_APP_PRODUCTION_API_URL
      : ENVIRONMENT === "uat"
      ? process.env.REACT_APP_UAT_API_URL
      : process.env.REACT_APP_DEVELOPMENT_API_URL,
  chatapiurl:
    ENVIRONMENT === "production"
      ? process.env.REACT_APP_PRODUCTION_CHAT_API_URL
      : ENVIRONMENT === "uat"
      ? process.env.REACT_APP_UAT_CHAT_API_URL
      : process.env.REACT_APP_DEVELOPMENT_CHAT_API_URL,
};

const getKey = (suffix) => {
  const envPrefix =
    ENVIRONMENT === "production"
      ? "prod"
      : ENVIRONMENT === "uat"
      ? "uat"
      : "dev";

  return `${process.env.REACT_APP_APP_COOKIE_NAME}_${envPrefix}_${suffix}`;
};

export const TOKEN_NAME = getKey("token");
export const COMPANYNAME = getKey("company_name");
export const NAME = getKey("name");
export const COMPANY_ID = getKey("company_id");
export const ROLE = getKey("role");
export const USERNAME = getKey("username");
export const COMPANY_EMPLOYEE_ID = getKey("company_employee_id");
export const IS_LIVE_TRACKING = getKey("is_live_tracking");
export const IS_CHAT = getKey("is_chat");
export const IS_HRMS = getKey("is_hrms");

export const ROLES = {
  COMPANY_ADMIN: "COMPANY_ADMIN",
  EMPLOYEE: "EMPLOYEE",
};

export const REDIRECT_URL =
  ENVIRONMENT === "production"
    ? process.env.REACT_APP_REDIRECT_PROD_DOMAIN
    : ENVIRONMENT === "uat"
    ? process.env.REACT_APP_REDIRECT_UAT_DOMAIN
    : process.env.REACT_APP_REDIRECT_DEV_DOMAIN;

export const SERVICE_KEY =
  ENVIRONMENT === "production"
    ? process.env.REACT_APP_HRMS_PROD_APP_ID
    : ENVIRONMENT === "uat"
    ? process.env.REACT_APP_HRMS_UAT_APP_ID
    : process.env.REACT_APP_HRMS_DEV_APP_ID;

export const GOOGLE_CLIENT_ID =
  ENVIRONMENT === "development"
    ? "625960954396-783so7uttthu1ph8djfbhl5grtre64fr.apps.googleusercontent.com"
    : ENVIRONMENT === "uat"
    ? "625960954396-a1bqga46vipgsv3fh67kl297ndj0oqs4.apps.googleusercontent.com"
    : "625960954396-a1bqga46vipgsv3fh67kl297ndj0oqs4.apps.googleusercontent.com"; // production

export const TAX = 175;
export const ABOVE_LIMIT_TAX = 200;
export const EXEED_MONTH_LIMIT = 300;
export const TDS = 10;
export const PERCENTILE = 100;
export const GST = "";

export const MIN_LEAVE_DATE_FOR_PL = 1;
export const MIN_LEAVE_DATE_FOR_CL = 5;

export const DISCRETIONAL_LEAVE_YEAR_IGNORE = 2022;

export const FULL_TIME_EMPLOYEE = 90;
export const PART_TIME_EMPLOYEE = 45;
export const ON_SIDE = 30;
export const REMOTE = 30;

export const NOTICE_PERIOD_EMPLOYEE = 45;
export const NOTICE_PERIOD_CONSULTANT = 30;

export const FULL_TIME_EMPLOYEE_LEAVES = {
  pl: 15,
  sl: 3,
  cl: 3,
};
export const PART_TIME_EMPLOYEE_LEAVES = {
  pl: 10,
  sl: 2,
  cl: 3,
};
export const ON_SITE_EMPLOYEE_LEAVES = {
  ol: 10,
};
export const REMOTE_EMPLOYEE_LEAVES = {
  holiday: 4,
};
